import { render } from "./PersAgeResume.vue?vue&type=template&id=9a9a4ed0"
import script from "./PersAgeResume.vue?vue&type=script&lang=js"
export * from "./PersAgeResume.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__